import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles(() => ({
  errorContainer: {
    color: "#ef7c83",
    marginBottom: 20,
  },
  newFormFieldsRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
  },
  newFormFieldsCol: {
    flex: 1,
    maxWidth: "48%",
  },
  newFormFieldSmallCol: {
    flex: 0.5,
    maxWidth: "20%",
  },
  errorField: {
    color: "#ef7c83",
    marginBottom: 20,
  },
  footerForm: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "2rem",
  },
}));
